export default __webpack_public_path__ + "static/media/Forward_Primer.c6c7fe79.svg";